import { forwardRef, ReactNode, Ref, useImperativeHandle } from 'react';
import { PopupHandles, PopupProps } from './Popup/type';
import { useCreatePopup } from './useCreatePopup';

const Popup = forwardRef(
  (
    props: {
      children: ReactNode;
      name?: string;
      type?: 'modal' | 'dropdown';
      hooks?: {
        onClose?: () => void;
      };
    } & PopupProps<any>,
    ref: Ref<PopupHandles<any>>,
  ) => {
    const { children, name, type, hooks, ...rest } = props;
    const { Component, ...api } = useCreatePopup({ name, type, hooks });

    useImperativeHandle(ref, () => api);

    return <Component {...rest}>{props.children}</Component>;
  },
);
export default Popup;
